var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup82Mobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 92,
    viewBox: "0 0 277 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_2501_1406)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.5,
    cy: 60.5,
    rx: 133.5,
    ry: 9.5,
    fill: "url(#paint0_linear_2501_1406)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.966 21.0486C229.144 22.368 228.7 23.8514 227.621 25.4926C226.54 27.1354 224.841 28.9065 222.566 30.7737C218.017 34.507 211.231 38.5715 202.699 42.7184C185.64 51.0094 161.669 59.5956 134.834 66.5057C107.999 73.4159 83.3998 77.3365 65.3241 78.0928C56.2834 78.4711 48.8932 78.0569 43.676 76.8385C41.0667 76.2291 39.0196 75.4227 37.5833 74.428C36.1484 73.4342 35.348 72.271 35.17 70.9517C34.9919 69.6323 35.4353 68.1489 36.5147 66.5077C37.5951 64.8649 39.2945 63.0938 41.5697 61.2266C46.1188 57.4933 52.9047 53.4288 61.4369 49.2819C78.496 40.9909 102.466 32.4047 129.301 25.4946C156.136 18.5844 180.736 14.6638 198.811 13.9075C207.852 13.5292 215.242 13.9434 220.46 15.1618C223.069 15.7712 225.116 16.5776 226.552 17.5723C227.987 18.5661 228.788 19.7293 228.966 21.0486Z",
    stroke: "url(#paint1_linear_2501_1406)",
    strokeWidth: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2501_1406",
    x: 0,
    y: 46,
    width: 277,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2501_1406"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2501_1406",
    x1: 48.4013,
    y1: 45.8846,
    x2: 61.0621,
    y2: 117.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AE6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC72FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2501_1406",
    x1: 27.1951,
    y1: 102.819,
    x2: 28.119,
    y2: 11.8056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AE6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC72FF",
    stopOpacity: 0.06
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup82Mobile);
export default __webpack_public_path__ + "static/media/group-82-mobile.4c5e9e490618208b1d3a95f9890d2c83.svg";
export { ForwardRef as ReactComponent };